/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/FreeCellLogic/ChallengeAuthorities/PlayValuesDailyFreeCellAuthority',[
    'SolitaireShared/FreeCellLogic/IDailyFreeCellAuthority',
    'SolitaireShared/CardLogic/IPlayValuesDailyAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/CardOp',
    'SolitaireShared/CardLogic/CardValue'

], function (IDailyFreeCellAuthority, IPlayValuesDailyAuthority, IDailyAuthority, CardOp, CardValue) {
    "use strict";


    var PlayValuesDailyFreeCellAuthority = function (param) {
        this.initPlayValuesDailyFreeCellAuthority(param);
    };

    PlayValuesDailyFreeCellAuthority.Key_NumToPlay = "NUMBERTOPLAY";
    PlayValuesDailyFreeCellAuthority.Key_ValueToPlay = "VALUETOPLAY";



    PlayValuesDailyFreeCellAuthority.prototype = Object.create(IDailyFreeCellAuthority.prototype);
    PlayValuesDailyFreeCellAuthority.prototype.constructor = PlayValuesDailyFreeCellAuthority;
    IPlayValuesDailyAuthority.call(PlayValuesDailyFreeCellAuthority.prototype);


    PlayValuesDailyFreeCellAuthority.prototype.initPlayValuesDailyFreeCellAuthority = function (param) {
        IDailyFreeCellAuthority.call(this, param);
        this._hasWon = false;

        var isDirty = true;
        if (param != null && param[PlayValuesDailyFreeCellAuthority.Key_NumToPlay] && param[PlayValuesDailyFreeCellAuthority.Key_ValueToPlay])
        {
            isDirty = false;

            this.NumToPlay = parseInt(param[PlayValuesDailyFreeCellAuthority.Key_NumToPlay]);
            this.ValueToPlay = CardValue.getValue(param[PlayValuesDailyFreeCellAuthority.Key_ValueToPlay]);

            if (isNaN(this.NumToPlay) || !this.ValueToPlay) {
                isDirty = true;
        }

        if (isDirty)
            throw "Invalid parameter passed in creating Daily Challenge";
        }

        this.ChallengeType = IDailyAuthority.ChallengeType.PlayValues;

    };


    Object.defineProperty(PlayValuesDailyFreeCellAuthority.prototype, "Value", {
        get: function () {
            return this.ValueToPlay;
        }
    });

    Object.defineProperty(PlayValuesDailyFreeCellAuthority.prototype, "NumberToPlay", {
        get: function () {
            return this.NumToPlay;
        }
    });

    Object.defineProperty(PlayValuesDailyFreeCellAuthority.prototype, "NumberPlayed", {
        get: function () {
            var numPlayed = 0;
            for (var i = 0; i < 4; i++)
            {
                var pile = this.CardSupply.GetPile("Foundation" + i);
                if (!pile.Empty && pile.Top.Value >= this.ValueToPlay)
                {
                    numPlayed++;
                }
            }
            return numPlayed;
        }
    });


    PlayValuesDailyFreeCellAuthority.prototype.Deal = function () {
        this._hasWon = false;

        return IDailyFreeCellAuthority.prototype.Deal.call(this);
    };

    PlayValuesDailyFreeCellAuthority.prototype.IsGameWon = function () {
        var numPlayed = 0;

        if (!this._hasWon)
        {
            numPlayed = this.NumberPlayed;
        }

        return (this._hasWon || numPlayed >= this.NumToPlay);
    };

    PlayValuesDailyFreeCellAuthority.prototype.GetHint = function (cycle, cheat)
    {

        if(cheat) {
            return IDailyFreeCellAuthority.prototype.GetHint.call(this,cycle,cheat);
        }

        cycle = !!cycle;

        var numTableaus = 8;
        var numFrees = 4;

        var hints = [];

        var a;
        this.CardSupply.GetPile("Foundation");
        var cards = [];
        cards.push("CHALLENGE");

        // Tableau-a-tableau matches first.
        for (var i = numTableaus - 1; i >= 0; i--)
        {
            a = this.CardSupply.GetPile("Tableau" + i);
            if (a.Empty)
                continue;

            var pileCards = a.GetCards();
            for (var ci = 0; ci < pileCards.length; ci++)
            {
                var c = pileCards[ci];
                if (c.Value == this.ValueToPlay)
                {
                    cards.push(c.Sequence.toString());
                }
            }
        }

        for (var i = 0; i < numFrees; i++)
        {
            a = this.CardSupply.GetPile("Free" + i);
            if (a.Empty)
                continue;

            if (a.Top.Value == this.ValueToPlay)
            {
                cards.push(a.Top.Sequence.toString());
            }
        }

        if (cards.length > 1)
        {
            var hint = new CardOp(this.CardSupply);

            hint.Parse(cards, 0);
            hints.push(hint);
        }

        return hints.length > 0 ? hints[0] : new CardOp(this.CardSupply);
    };

    return PlayValuesDailyFreeCellAuthority;

});
